import { createContext } from 'utils/react-helpers';

const [AggregationsProvider, useAggregations] = createContext({
  name: 'AggregationsContext',
});

export { AggregationsProvider, useAggregations };
